import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { BrandAccountsList } from './components/BrandAccountsList'
import { useMainQuery } from './hooks/useMainQuery'

export const BrandAccountsListPage = () => {
  const { isLoading } = useMainQuery()

  useLogEventOnMount('Access to brand account list')

  return (
    <Suspense loading={isLoading}>
      <BrandAccountsList />
    </Suspense>
  )
}
